const keys = {
  lastWorkspaceIdKey: 'lastWorkspaceId',
  userProfile: 'user:profile',
  userAllAuthorizations: 'user:allAuthorizations',
  /* This should be removed after release of SSO and once no one is using older versions */
  legacyUserAuthorization: 'user:authorization',

  devTools: 'devTools',

  isRunningCypressTests: 'cypress:isRunningCypressTests',
  /**
   * Allow the document layout setting to be persist in storage
   */
  documentLayout: 'user:documentLayout',
  /**
   * Workspaces where the Welcome Modal was dismissed
   * (The Welcome Modal won't appear again)
   */
  dismissedWelcomeModal: 'dismissedWelcomeModal',
  /**
   * BannerCards can be dismissed and for now we save it in local storage
   */
  dismissedBannerCards: 'dismissedBannerCards',
  /**
   * Set once the user has seen the Safari 14.1 performance warning in relation
   * to the Web Renderer for the first time.
   */
  safariGPUWarning: 'user:safariGPUWarning',
  /**
   * Whether the canvas beta feature preview panel is open or closed.
   */
  canvasBetaFeaturePreviewClosed: 'user:canvasBetaFeaturePreviewClosed',
} as const

export default keys

// Keys that belong to an authorized user
// These need to be cleared when signing out
const allowedKeys = Object.values(keys)
export const authorizationKeys: typeof allowedKeys = [
  'user:profile',
  'user:authorization',
  'user:allAuthorizations',
]
